import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalNoticeComponent } from './legal-notice.component';
import { createCustomElement } from '@angular/elements';
import { IframeModalModule } from '../iframe-modal/iframe-modal.module';

@NgModule({
  declarations: [LegalNoticeComponent],
  imports: [CommonModule, IframeModalModule],
})
export class LegalNoticeModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(LegalNoticeComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-legal-notice', customComponent);
  }
}
